export const SDK_VERSION = '1.1.1'
